import { IntlShape, useIntl } from 'react-intl';
import { Note } from '@rossum/api-client/notes';
import { Chip } from '@rossum/ui/material';

type CommentType = Note['type'];

type CommentsChipProps = {
  commentType: CommentType;
};

type EligibleCommentTypes = Exclude<CommentType, 'comment'>;

const getCommentTypeMap = (intl: IntlShape) =>
  ({
    rejection: {
      label: intl.formatMessage({
        id: 'components.documentComments.chip.rejection',
      }),
      color: 'error',
    },
    postponement: {
      label: intl.formatMessage({
        id: 'components.documentComments.chip.postponement',
      }),
      color: 'warning',
    },
  }) as const satisfies Record<
    EligibleCommentTypes,
    { label: string; color: 'error' | 'success' | 'warning' }
  >;

const isEligible = (
  commentType: CommentType
): commentType is EligibleCommentTypes =>
  ['rejection', 'postponement'].includes(commentType);

export const CommentsChip = ({ commentType }: CommentsChipProps) => {
  const intl = useIntl();

  if (!isEligible(commentType)) return null;

  const commentTypeMap = getCommentTypeMap(intl);
  const commentChip = commentTypeMap[commentType];
  return (
    <Chip
      label={commentChip.label}
      color={commentChip.color}
      sx={{ alignSelf: 'flex-start' }}
    />
  );
};
